import { useEffect, useState } from "react";
import { Plus, Trash, WhatsappLogo } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, fmtDate } from "@/lib/api";
import { PLACES } from "@/components/guest/Explore";

export function PlaceList({ items, onChange }) {
  const set = (i, k, v) => onChange(items.map((it, j) => (j === i ? { ...it, [k]: v } : it)));
  return (
    <div className="space-y-3 sm:col-span-2" data-testid="guide-nearby">
      {items.map((it, i) => (
        <div key={i} className="grid gap-2 rounded-xl border border-border p-3 sm:grid-cols-[140px,1fr,1fr,auto]">
          <Select value={it.category || "general"} onValueChange={(v) => set(i, "category", v === "general" ? "" : v)}>
            <SelectTrigger className="h-9" data-testid={`guide-nearby-${i}-category`}><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="general" data-testid={`guide-nearby-${i}-category-general`}>General</SelectItem>
              {PLACES.map(([k, l]) => <SelectItem key={k} value={k} data-testid={`guide-nearby-${i}-category-${k}`}>{l}</SelectItem>)}
            </SelectContent>
          </Select>
          <Input placeholder="Place, e.g. Cafe Javas" value={it.name || ""} onChange={(e) => set(i, "name", e.target.value)} data-testid={`guide-nearby-${i}-name`} />
          <Input placeholder="Note, e.g. 5 min walk" value={it.note || ""} onChange={(e) => set(i, "note", e.target.value)} data-testid={`guide-nearby-${i}-note`} />
          <button type="button" onClick={() => onChange(items.filter((_, j) => j !== i))} className="px-2 text-muted-foreground hover:text-destructive" data-testid={`guide-nearby-${i}-remove`}><Trash /></button>
          <Input className="sm:col-span-3 sm:col-start-2" placeholder="Google Maps link (optional)" value={it.map_url || ""} onChange={(e) => set(i, "map_url", e.target.value)} data-testid={`guide-nearby-${i}-map`} />
        </div>
      ))}
      <button type="button" onClick={() => onChange([...items, { category: "restaurants", name: "", note: "", map_url: "" }])} data-testid="guide-nearby-add" className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#D96C4A]"><Plus weight="bold" /> Add a place</button>
    </div>
  );
}

export function WaAlertLog({ pid }) {
  const [log, setLog] = useState(null);
  useEffect(() => { if (pid) api.get(`/properties/${pid}/wa-alerts`).then((r) => setLog(r.data)).catch(() => {}); }, [pid]);
  const label = { sent: "Sent", failed: "Not delivered", sending: "Sending", not_connected: "Not sent yet" };
  return (
    <div className="space-y-2 sm:col-span-2" data-testid="wa-alert-log">
      {log && !log.connected && <p className="rounded-xl bg-[#FBEBD2] px-4 py-3 text-xs text-[#8A5A12]" data-testid="wa-not-connected">WhatsApp sending isn't connected yet. Alerts are saved below and will start sending once Hostkey connects a WhatsApp account.</p>}
      {log?.connected && <p className="rounded-xl bg-[#E3EEE2] px-4 py-3 text-xs text-[#2C4E2A]" data-testid="wa-connected">WhatsApp is connected. You'll get a message the moment a guest checks in.</p>}
      {(log?.items || []).slice(0, 5).map((a) => (
        <div key={a.alert_id} className="flex items-start gap-2 rounded-xl bg-secondary px-3 py-2 text-xs" data-testid={`wa-alert-${a.alert_id}`}>
          <WhatsappLogo size={16} className="mt-0.5 shrink-0 text-[#25D366]" />
          <div className="min-w-0"><p>{a.message}</p><p className="mt-0.5 text-muted-foreground">To {a.to} · {fmtDate(a.created_at)} · <span className={a.status === "failed" ? "text-red-600" : a.status === "sent" ? "text-[#2F6B4F]" : ""} data-testid={`wa-alert-status-${a.alert_id}`}>{label[a.status] || a.status}</span>{a.error ? ` (${a.error})` : ""}</p></div>
        </div>
      ))}
    </div>
  );
}
